import { useEffect } from 'react';

import { formatDocumentTitle } from 'src/utils/helpers/documentTitle';

export const useDocumentTitle = (pageName) => {
	useEffect(() => {
		document.title = formatDocumentTitle(pageName);
	}, [pageName]);
};
